export default __webpack_public_path__ + "39106f1c703f18c8bb8adcf5d510f3f2.svg";